/* istanbul ignore file */
/**
 * Created by vsuthar on 8/27/21
 * File: TenancyService
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

import axios from 'axios'
import { getVarValue } from '../../common/utils/Sparky'
import { getTsgToken, getFrameworkServiceUrl } from '@sparky/framework'
import { FF_USE_LOCAL_TENANCY_SERVICE } from '../../common/utils/FeatureFlags'

const includeClaims = getVarValue(FF_USE_LOCAL_TENANCY_SERVICE, false)

/**
 *
 * @type {null}
 */
const TENANT_URL_KEY = 'tenant_base_url'
const TENANCY_SERVICE_URL_KEY = 'tenancy_service'
const TenancyAPI = axios.create({
  baseURL: getFrameworkServiceUrl(TENANCY_SERVICE_URL_KEY) || getVarValue(TENANT_URL_KEY),
  timeout: 300 * 1000,
})

TenancyAPI.interceptors.request.use(async config => {
  const token = await getTsgToken(config?.tsg_id)
  config.headers = { ...config.headers, 'Authorization': `Bearer ${token}` }
  if (includeClaims) {
    config.headers.claims = token.split('.')[1]
  }
  return config
}, error => {
  return Promise.reject(error)
})

TenancyAPI.interceptors.response.use((response) => response, (error) => {
  throw new Error(error.response?.data?.message || error.response?.data?.msg || error.message)
})

const TenancyService = {
  listTenant: {
    get: ({ tsg_id }) => TenancyAPI.get('/tenant_service_groups', { params: { hierarchy: true }, tsg_id }),
    post: (data, tsg_id) => TenancyAPI.post('/tenant_service_groups', data, { tsg_id }),
    put: async (tsg_id, data) => {
      if (tsg_id) {
        return TenancyAPI.put(`/tenant_service_groups/${tsg_id}`, data, { tsg_id })
      }
      new Error('TSG ID is required')
    },
    delete: async (tsg_id) => {
      if (tsg_id) {
        return TenancyAPI.delete(`/tenant_service_groups/${tsg_id}`, { tsg_id })
      }
      new Error('TSG ID is required')
    }
  },
  acquisitions: {
    list: (tsg_id) => TenancyAPI.get('/acquisitions', { tsg_id }),
    get: (tsg_id, acquisition_id) => TenancyAPI.get(`/acquisitions/${acquisition_id}`, { tsg_id }),
    create: (tsg_id, payload) => TenancyAPI.post('/acquisitions', payload, { tsg_id }),
    delete: (tsg_id, acquisition_id) => TenancyAPI.delete(`/acquisitions/${acquisition_id}`, { tsg_id })
  },
  acquisitionRequests: {
    list: (tsg_id) => TenancyAPI.get('/acquisition_requests', { tsg_id }),
    get: (tsg_id, acquisition_id) => TenancyAPI.get(`/acquisition_requests/${acquisition_id}`, { tsg_id }),
    resendEmail: (tsg_id, acquisition_id) => TenancyAPI.post(`/acquisition_requests/${acquisition_id}:resend`, {}, { tsg_id }),
    acknowledge: (tsg_id, acquisition_id, payload) => TenancyAPI.post(`/acquisition_requests/${acquisition_id}:acknowledge`, payload, { tsg_id }),
  },
  tenantServiceGroups: {
    move: (tsg_id, parent_id) => TenancyAPI.post('/move_tenant_service_group', { parent_id }, { tsg_id }),
  }
}

export default TenancyService

